import React from "react";
import "./SectionHeader.css";

const SectionHeader = ({
  eyebrow,
  title,
  description,
  align = "center",
  dark = false,
}) => (
  <div
    className={`vp-section-header vp-section-header--${align}${dark ? " vp-section-header--dark" : ""}`}
  >
    {eyebrow && <span className="vp-eyebrow">{eyebrow}</span>}
    {title && <h2 className="vp-section-title">{title}</h2>}
    {description && <p className="vp-section-desc">{description}</p>}
  </div>
);

export default SectionHeader;
